module.exports = __webpack_public_path__ + "1aa68d61eec9aec8df0b6919fea5b3bb.svg";